module.exports = __webpack_public_path__ + "static/media/img_join_process.2856b1c9.png";